import {
  globalDeleteService,
  globalGetService,
  globalPostService,
  globalPutService,
} from '@/utils/globalApiServices';

import { CreateSenderIdParams, SenderId } from './types';

export const createSenderIds = async (
  brandUid: string,
  data: CreateSenderIdParams | CreateSenderIdParams[]
) => {
  const response = await globalPostService(
    `csp/brands/${brandUid}/senderIds`,
    Array.isArray(data) ? data : [data]
  );
  return (response?.ok ? response.data : []) as SenderId[];
};

export const getSenderIds = async (brandUid: string) => {
  const response = await globalGetService(`csp/brands/${brandUid}/senderIds`);
  return (response?.ok ? response.data : []) as SenderId[];
};

export const getSenderId = async (brandUid: string, senderIdUid: string) => {
  const response = await globalGetService(
    `csp/brands/${brandUid}/senderIds/${senderIdUid}`
  );
  return response?.ok ? (response.data as SenderId) : undefined;
};

export const deleteSenderId = async (brandUid: string, senderIdUid: string) => {
  const response = await globalDeleteService(
    `csp/brands/${brandUid}/senderIds/${senderIdUid}`
  );
  return !!response?.ok;
};

export const updateSenderId = async (
  brandUid: string,
  senderIdUid: string,
  data: CreateSenderIdParams
) => {
  const response = await globalPutService(
    `csp/brands/${brandUid}/senderIds/${senderIdUid}`,
    data
  );
  return response?.ok ? (response.data as SenderId) : undefined;
};
